module.exports = __webpack_public_path__ + "static/20c5543d1a28e4aa7c929d2db29a18be481c87f54db5ca5243096c5cff271746-7bc4adbd30fe7ae1df1231cffc92ebac.png";